import { gql } from '@apollo/client'

/**
 * Initiate user workspace verification which retrieves the various ways a user can verify their workspace
 */
export const INITIATE_WORKSPACE_VERIFICATION = gql`
  mutation InitiateWorkspaceVerification($companyIdentifier: CompanyIdentifierInput!, $workspaceID: ID!) {
    initiateWorkspaceVerification(input: { companyIdentifier: $companyIdentifier, workspaceID: $workspaceID }) {
      isVerified
    }
  }
`

/**
 * Requests to send a verification code
 */
export const SEND_VERIFICATION_CODE = gql`
  mutation SendVerificationCode($method: String!, $type: String!, $value: String) {
    sendVerificationCode(input: { method: $method, type: $type, value: $value }) {
      id
    }
  }
`

/**
 * Requests to send a verification code
 */
export const REQUEST_CUSTOM_VERIFICATION = gql`
  mutation RequestCustomVerification($input: RequestCustomVerificationDTO!) {
    requestCustomVerification(input: $input) {
      id
    }
  }
`

/**
 * Verifies the code for workspace verification
 *
 * @param code the verification code
 */
export const VERIFY_CODE_FOR_VERIFIED_STATUS = gql`
  mutation VerifyCodeForVerifiedStatus($code: String!) {
    verifyCodeForVerifiedStatus(input: { code: $code }) {
      id
    }
  }
`

/**
 * Update workspace details
 * @param displayName workspace's name
 */
export const UPDATE_WORKSPACE = gql`
  mutation UpdateWorkspace($displayName: String!) {
    updateWorkspace(input: { displayName: $displayName }) {
      id
    }
  }
`

/**
 * Deletes workspace
 */
export const DELETE_WORKSPACE = gql`
  mutation DeleteWorkspace($workspaceID: ID!) {
    deleteWorkspace(input: { workspaceID: $workspaceID }) {
      id
    }
  }
`

export const UPDATE_WORKSPACE_LOGO = gql`
  mutation UpdateWorkspaceLogo($workspaceLogoURL: String!) {
    updateWorkspaceLogo(input: { workspaceLogoURL: $workspaceLogoURL }) {
      id
    }
  }
`

export const REMOVE_WORKSPACE_LOGO = gql`
  mutation {
    removeWorkspaceLogo {
      id
    }
  }
`

/**
 * Updates a workspace page details
 *
 * @param bio the bio of the workspace
 * @param freightPreferences the freight preferences of the workspace
 */
export const UPDATE_WORKSPACE_PAGE = gql`
  mutation UpdateWorkspacePage($bio: String!, $freightPreferences: [String]!) {
    updateWorkspacePage(input: { bio: $bio, freightPreferences: $freightPreferences }) {
      id
      workspacePage {
        bio
        freightPreferences
      }
    }
  }
`

/**
 * Creates an API key with specified scopes
 */
export const CREATE_API_KEY = gql`
  mutation CreateAPIKey($scopes: [String!]) {
    createAPIKey(input: { scopes: $scopes }) {
      value
    }
  }
`

export const DELETE_API_KEY = gql`
  mutation DeleteAPIKey($apiKey: String!) {
    deleteAPIKey(input: { apiKey: $apiKey }) {
      id
    }
  }
`

export const UPDATE_API_KEY = gql`
  mutation UpdateAPIKey($apiKey: String!, $scopes: [String!]) {
    updateAPIKey(input: { apiKey: $apiKey, scopes: $scopes }) {
      id
    }
  }
`
